import "./styles/GiftLanding.css";
import heroCouple from "../../assets/hero_gift_photo.jpg";
import heartPng from "../../assets/heart.png";
import { MapPin, LockKeyhole, Gift as GiftIcon, LineChart } from "lucide-react";

export default function GiftLanding({ onCtaClick }) {
  return (
    <>
      <h1 className="gift-headline">
        Give the <span className="accent">certainty of sunshine</span>
      </h1>
      <section className="gift-landing v3">
        {/* hero image */}
        <div className="gift-photo">
          <img src={heroCouple} alt="Happy couple under clear skies" />
          <img src={heartPng} alt="" className="floating-heart" />
        </div>

        {/* copy & CTA */}
        <div className="gift-copy-block">
          <p className="gift-sub">
            Unlock year‑ahead, <strong>venue‑specific forecasts</strong> so your
            favourite couple can plan with confidence.
          </p>

          <button className="btn-primary" onClick={onCtaClick}>
            Start Your Gift
          </button>

          <div className="gift-proof">
            <LineChart size={16} /> Powered by Climformatics
          </div>
        </div>

        {/* benefit banner */}
        <ul className="gift-banner banner-cards">
          <Benefit
            icon={<LockKeyhole size={36} />}
            text="Lock the perfect date"
          />
          <Benefit icon={<MapPin size={36} />} text="Venue‑level accuracy" />
          <Benefit
            icon={<GiftIcon size={36} />}
            text="Transferable in one click"
          />
        </ul>
      </section>
    </>
  );
}

function Benefit({ icon, text }) {
  return (
    <li className="banner-item">
      <span className="banner-icon">{icon}</span>
      <span className="banner-text">{text}</span>
    </li>
  );
}
